import React from 'react';

export interface ColorSwatchProps {
  color: string;
  setOpen: () => void;
  open?: boolean;
}

export const ColorSwatch: React.FC<ColorSwatchProps> = ({ color, setOpen, open }) => {
  return (
    <div
      className={`
        h-8 w-8
        rounded-sm
        cursor-pointer
        transform
        scale-100
        transition duration-40
        ${!open && 'hover:scale-110'}
        ${open && 'ring-4 ring-voxel-blue-500 z-10'}
      `}
      onClick={() => setOpen()}
      style={{ backgroundColor: color }}
    />
  );
};

export default ColorSwatch;
